import styled, { withTheme } from "styled-components";
import { Button as AntButton, Menu } from "antd";
import { Metrics, Colors } from "../../theme";

export const DropdownMenu = styled(Menu).attrs({mode:"vertical"})`
    ${props=>`
        border-left-width: ${Metrics.thinBorderWidth}px solid ${props.theme.button.textColor};
        border-right-width: ${Metrics.thinBorderWidth}px solid ${props.theme.button.textColor};
    `}
`;
export const DropdownMenuIem = styled(Menu.Item)`
    background-color:${Colors.subColor};
    color:${props=>props.theme.button.textColor};
    border-radius: ${Metrics.borderRadius}px;
    &:hover {
        background-color:${props=>props.theme.button.textColor};
        color:${Colors.subColor};
        border-color:${props=>props.theme.button.textColor};
        ${props=>`
            border-left: ${Metrics.thinBorderWidth}px solid ${Colors.subColor};
            border-right: ${Metrics.thinBorderWidth}px solid ${Colors.subColor};
        `}
    }
`;
export const DropdownSubMenu = styled(Menu.SubMenu)`
    background-color:${Colors.subColor};
    color:${props=>props.theme.button.textColor};
    border-radius: ${Metrics.borderRadius}px;
    p {
        display:inline;
        color:${props=>props.theme.button.textColor};
    }
    &:hover {
        background-color:${props=>props.theme.button.textColor};
        color:${Colors.subColor};
        border-color:${props=>props.theme.button.textColor};
        ${props=>`
            border-left: ${Metrics.thinBorderWidth}px solid ${Colors.subColor};
            border-right: ${Metrics.thinBorderWidth}px solid ${Colors.subColor};
        `}
        p {
            color:${Colors.subColor};
        }
    }
    ${"" /* display:flex;
    align-items:center;
    background-color:${Colors.subColor};
    color:${props=>props.theme.button.textColor};
    border-width: 0px;
    border-radius: ${Metrics.borderRadius}px;
    padding-left: ${Metrics.menuItem.indentSize}px;
    ${props=>props.minWidth ? `min-width: ${props.minWidth}px;` : ``}
    &:hover {
        background-color:${props=>props.theme.button.textColor};
        color:${Colors.subColor};
        border-color:${props=>props.theme.button.textColor};
        ${props=>`
            border-left: ${Metrics.thinBorderWidth}px solid ${Colors.subColor};
            border-right: ${Metrics.thinBorderWidth}px solid ${Colors.subColor};
        `}
    } */}
`;
export const SubMenuPlaceholder = withTheme(styled.div`
    background-color:${Colors.subColor};
    color:${props=>props.theme.button.textColor};
    border-width: 0px;
    border-radius: ${Metrics.borderRadius}px;
    ${props=>props.minWidth ? `min-width: ${props.minWidth}px;` : ""}
    &:hover {{
        background-color:${Colors.subColor};
        color:${props=>props.theme.button.textColor};
    }}
`);

export const DropdownButtonPlaceholer = withTheme(styled(AntButton)`
    background-color:${Colors.subColor};
    color:${props=>props.theme.button.textColor};
    border-width: 0px;
    border-radius: ${Metrics.borderRadius}px;
    height: ${props=>props.height ? props.height : Metrics.button.wrapperHeight}px;
    ${props=>props.minWidth ? `min-width: ${props.minWidth}px;` : ""}

    &:hover {{
        background-color:${Colors.subColor};
        color:${props=>props.theme.button.textColor};
    }}
`);


// WEBPACK FOOTER //
// ./src/components/button/Dropdown.js